export const checkoutLabels = {
  expressCheckoutHeader: 'Review your order',
  plansHeader: 'Internet, Perks & Services',
  maximumQuantity: 10,
  discountApplied: 'Discount applied',
  continueCta: 'Continue',
  scheduleCTA: 'Schedule',
  learnMore: 'Learn more',
  updateSelectedNotification: 'We’ve updated setup and pre-selected shipping details. Update any of these by clicking on the arrows.',
  preSelectedNotification: 'We’ve pre-selected setup, contact and shipping details. Update any of these by clicking on the arrows.',
  dawText:
    'Receive $10/mo discount, sign up for Auto Pay and paper-free billing with a debit card, bank account or the Verizon Visa card once your internet service is activated.',
  dawTooltip: 'Your discount will be applied beginning with your next bill cycle and will remain as long as you’re enrolled.',
  ipiLinkText: 'Important Plan Information',
  ibiLinkText: 'Important Broadband Information',
  ipiUrl: '/content/support/terms/products/important-plan-information/_jcr_content.raw.json',
  ibiUrl: '/content/support/terms/products/important-plan-information/_jcr_content.raw.json',
  expressShippingHeader: 'Shipping address',
  checkoutHeading: 'Checkout Information',
  expressPaymentHeader: 'Payment Method',
  CustomerInformation: 'Customer information',
  BTA: 'Bill to my Verizon account',
  SI: 'Shipping information',
  inStore: 'In-store pickup address',
  gov_ID: ', remenber to bring your government-issued ID when you pick up your equipment',
  contact_info_email_helper_text: 'Your email will be used to provide order details, account updates and special offers.',
  contact_info_mobile_label: 'Mobile Phone Number',
  firstNameRequiredError: 'You must enter a First name.',
  lastNameRequiredError: 'You must enter a Last name.',
  maxtAttemptsText: "You've changed your email address too many times. Please try again later.",
  tooltTipText: 'For security, we need to confirm this email address is valid.',
  notificationText: "We've sent an email to <email address>. After validating your email address,<br>click Confirm below.",
  orderSummary: 'Order Summary',
  estimatedBillSummary: 'Combined home & mobile bill estimate',
  estimatedBillDescription5G:
    'Includes 5G Home Internet and all Verizon products & services (plus taxes, surcharges and government fees) associated with your account. There may be a pro-rated monthly charge covering the time between when your service was activated and your regular monthly billing cycle date.',
  estimatedBillDescriptionLTE:
    'Includes LTE Home Internet and all Verizon products & services (plus taxes, surcharges and government fees) associated with your account. There may be a pro-rated monthly charge covering the time between when your service was activated and your regular monthly billing cycle date.',
  checkBoxText:
    "Yes, I'd like to receive special offers and updates by calls or automated texts to the mobile number provided. Consent is not a condition to purchase products or services. Standard messaging rates may apply",
  noficationForDuePayment: "We've pre-selected setup, contact, payment details and shipping details. Update any of these by clicking on the arrows.",
};
